/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterA = createReactComponent(
  "square-rounded-letter-a",
  "IconSquareRoundedLetterA",
  [
    ["path", { d: "M10 16v-6a2 2 0 1 1 4 0v6", key: "svg-0" }],
    ["path", { d: "M10 13h4", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedLetterA as default };
//# sourceMappingURL=IconSquareRoundedLetterA.js.map
